export const Select = {
  variants: {
    outline: {
      field: {
        _focusWithin: {
          border: "1px",
          borderColor: "brand.primary",
          boxShadow: "none",
        },
      },
    },
    create: {
      field: {
        border: "1px",
        borderColor: "warmNeutral.200",
        _focusWithin: {
          borderColor: "warmNeutral.600",
          boxShadow: "none",
        },
      },
    },
    warmNeutral: {
      field: {
        background: "white",
        borderRadius: "md",
        border: "1px solid",
        borderColor: "warmNeutral.200",
        color: "baseBlack",
        _focus: {
          borderColor: "warmNeutral.500",
          boxShadow: "none",
        },
        _placeholder: {
          color: "neutral.400",
        },
        _invalid: {
          borderColor: "error",
        },
      },
      icon: {
        color: "warmNeutral.700",
      },
    },
  },
};
